var searchSuggester = {
	inputPlaceholder: "Suche",
	clearSearchTerm: "Suchbegriff löschen",
	noResults: "Keine Ergebnisse gefunden",
	allSearchResults: "Alle Suchergebnisse",
	validationErrors: {
		searchTerm: {
			invalidInput: "Ungültige Eingabe"
		}
	}
};
var searchSuggesterTranslationsDe = {
	searchSuggester: searchSuggester
};

export { searchSuggesterTranslationsDe as default, searchSuggester };
